import React, { useState, useEffect } from 'react';
import { Margin, ButtonCleanFilter } from '@catalogo/ui-americanas-desktop-product-review/src/components/atoms';
import { Wrapper, ButtonBack, Filter, Title, WrapperTitle } from './Styled';
import { FilterRating, TypeOfReview } from '../';
import { ModalSheet } from '../';

const FilterSelects = ({ dispatchMetrics, filterParams }: any) => {
  const [disabled, setDisabled] = useState(true);
  const [visible, setVisible] = useState(false);
  const exitFunc = () => setVisible(false);
  const toggleModal = React.useCallback(() => setVisible(!visible), [visible]);

  useEffect(() => {
    if (filterParams?.badges || filterParams?.rating.length !== 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [filterParams]);

  useEffect(() => {
    const handleAfterClick = (e: any) => {
      const clickOutside = e.target.className.includes('src__Wrapper');
      if (clickOutside) {
        toggleModal();
      }
    };

    if (visible) {
      document.addEventListener('click', handleAfterClick);
    }

    return () => {
      document.removeEventListener('click', handleAfterClick);
    };
  }, [visible, toggleModal]);

  return (
    <>
      <Wrapper onClick={toggleModal} className="product-review-filter-selects">
        <Filter width="14" height="14" className="product-review-filter-selects-icon" />
        filtrar
      </Wrapper>
      <ModalSheet visible={visible} exitFunc={exitFunc}>
        <WrapperTitle className="product-review-filter-selects-modal-sheet-title">
          <Title className="product-review-filter-selects-modal-sheet-title-text">filtrar por</Title>
          <ButtonCleanFilter bold={true} />
        </WrapperTitle>
        <TypeOfReview dispatchMetrics={dispatchMetrics} />
        <Margin bottom={16} />
        <FilterRating dispatchMetrics={dispatchMetrics} />
        <Margin bottom={24} />
        <ButtonBack
          onClick={exitFunc}
          disabled={disabled}
          className="primary product-review-filter-selects-button-back"
        >
          ver comentários
        </ButtonBack>
      </ModalSheet>
    </>
  );
};

export default FilterSelects;
export { FilterSelects };
